import { useQuery } from '@tanstack/react-query'
import { MeApi } from '@ulysses-inc/harami_api_client'
import { useAuthApi } from '~/adapter/api/useAuthApi'
import { Me } from '~/domain/me/me'
import { getQueryKey } from '~/lib/tanstackQuery/queryKey'

/**
 * 認証主体 (Principal) 自身の情報 (GET /me) を取得する。
 * レスポンスはドメインモデル Me に変換して返す (アンチコラプションレイヤー)。
 */
export const useQueryMe = ({ enabled } = { enabled: true }) => {
  const { getApi } = useAuthApi()

  return useQuery({
    queryKey: getQueryKey('/me', 'GET'),
    queryFn: async () => {
      return await getApi(MeApi).getMe()
    },
    select: Me.fromResponse,
    enabled,
    // NOTE: 全体オプションではtrueになっている。このクエリを使う箇所共通化されているような箇所のため、ErrorBoundaryでエラーをキャッチして処理するよりも、例外的に個別にハンドリングする方がスッキリするため
    throwOnError: false,
    // NOTE: staleTime と gcTime を 0 に設定することで、常に最新のデータを取得する
    gcTime: 0,
    staleTime: 0,
  })
}
